import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {NavigationService} from "../../../service/navigation.service";

@Injectable()
export class AuthGuard implements CanActivate {
  // storage = sessionStorage;
  storage = localStorage;

  constructor(private navigationService: NavigationService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    // let storage = sessionStorage;
    if (this.storage.getItem('currentUser')) {
      return true;
    }

    // not logged in so redirect to login page with the return url
    //this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
    this.navigationService.goToHomePage();

    return false;
  }
}
